import * as Sentry from "@sentry/vue";
import type { App } from "vue";

type Props = {
    app: App<Element>;
};

export const initSentry = ({ app }: Props) => {
    // Do not initialize Sentry in local or CI environments
    if (import.meta.env.VITE_APP_ENV === "local" || import.meta.env.VITE_APP_ENV === "CI") return;

    Sentry.init({
        app,
        dsn: "https://908b72694bd09c56fef51795bf9852eb@o4509557667266560.ingest.de.sentry.io/4509557756723280",
        sendDefaultPii: true,
        tracesSampleRate: 0.1,
        integrations: [Sentry.browserTracingIntegration()],
        environment: import.meta.env.VITE_APP_ENV,
    });
};
